<template>
    <auth-layout>
        <header-page title="Panduan Menulis"/>
        <div class="wrap-page-panduan">
            <div class="panduan-list" v-for="item in data" v-bind:key="item._id">
                <div class="wrap-icon">
                    <i class="icon icon-panduan-news"></i>
                </div>
                <div class="panduan-list-title">
                    <span class="pointer" @click="openModal(item._id)">{{ item.judul }}</span>
                    <!-- Modal -->
                    <div class="modal fade" :id="item._id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">{{ item.judul }}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" v-html="item.konten"></div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6"><button type="submit" class="btn btn-primary main-button pill-button" @click="prevPage" :disabled="current_page === 1">Sebelumnya</button></div>
            <div class="col-6"><button type="submit" class="btn btn-primary main-button pill-button" @click="nextPage" :disabled="!next_page_url">Berikutnya</button></div>
        </div>
    </auth-layout>
</template>
<style scoped>
.wrap-page-panduan{
    padding: 0 5%;
}
.panduan-list {
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
}
.panduan-list .wrap-icon {
    margin-right: 10px;
}
.panduan-list-title {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
}
.panduan-list-title a {
    color: #333333;
}
.panduan-list-title a:hover {
    text-decoration: none;
}
.panduan-list:last-child {
    border-bottom: none;
}
</style>

<script>
import axios from "axios";
import $ from "jquery";

export default {
    data() {
        return {
            data: [],
            loading: true,
            current_page: 1,
            per_page: '',
            last_page: '',
            to: '',
            total: '',
            next_page_url: ''
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        openModal(id) {
            $(`#${id}`).modal('show');
        },
        getData (page = 1) {
            const token = this.$cookies.get('token');
            axios.get(`/api/rule?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.data = response.data.data
                    this.current_page = response.data.current_page
                    this.per_page = response.data.per_page
                    this.last_page = response.data.last_page
                    this.to = response.data.to
                    this.total = response.data.total
                    this.next_page_url = response.data.next_page_url
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        nextPage() {
            const page = this.current_page + 1;
            this.getData(page)
            window.scrollTo(0,0);
        },
        prevPage() {
            const page = this.current_page - 1;
            this.getData(page)
            window.scrollTo(0,0);
        }
    }
}
</script>
